import { Module } from 'vuex'
import { RootState } from '@/store'
import mutations from '@/store/order/mutations'
import { path } from '@/store/order/types'
import { mutation } from '@/utils/mutation'
import state, { IOrderState } from '@/store/order/state'

export * from '@/store/order/state'

export const store: Module<IOrderState, RootState> = {
  state,
  mutations: mutation(mutations, path)
}
